import React, { useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Container } from "react-bootstrap";
import BtnBGImg from "../../../src/assets/img/subheader-btn-back.png";
import FireParticles from "../../FireParticles";

const Home = () => {
  // Load Facebook SDK
  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v18.0";
      script.async = true;
      script.crossOrigin = "anonymous";
      script.onload = () => {
        if (window.FB) window.FB.XFBML.parse();
      };
      document.body.appendChild(script);
    } else {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <>
      <FireParticles />

      <Container>
        <Grid container spacing={2} py={5}>
          {/* LEFT SIDE: Text Content */}
          <Grid item xs={12} md={7} textAlign="center">
            <Box
              sx={{
                animation: "fadeIn 1.2s ease-out",
                "@keyframes fadeIn": {
                  from: { opacity: 0, transform: "translateY(-10px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  textAlign: "start",
                  fontSize: { xs: "28px", sm: "34px", md: "110px" },
                  marginTop: "20px",
                  marginBottom: "30px",
                  fontWeight: "bold",
                  letterSpacing: 2,
                  backgroundImage:
                    "-webkit-linear-gradient(90deg, #ffd786 0%, #a6753a 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                <Box component="span" sx={{ display: "block" }}>
                  DarkNova
                </Box>
                <Box component="span" sx={{ display: "block" }}>
                  Conquer
                </Box>
              </Typography>
            </Box>

            <Typography
              sx={{
                color: "#DCDCDC",
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                lineHeight: "38px",
                maxWidth: "720px",
                mb: 6,
                textAlign: { xs: "center", md: "left" },
                mx: { xs: "auto", md: 0 },
              }}
            >
              Step into a breathtaking fantasy world inspired by the rich
              landscapes of South East Asia! <strong>DarkNova Conquer</strong> is
              a classic, free-to-play MMORPG where you become a fearless hero,
              ready to battle monsters, conquer quests, and forge your own legend.
              With fast-paced combat, a massive community, and addictive gameplay,
              <strong> DarkNova Conquer</strong> delivers endless excitement and
              epic battles.
            </Typography>

            <Box
              onClick={() => console.log("Image button clicked")}
              sx={{
                position: "relative",
                display: "inline-block",
                cursor: "pointer",
                overflow: "hidden",
                transition:
                  "transform 0.2s ease, filter 0.2s ease, box-shadow 0.2s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  filter: "brightness(1.4)",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <Box
                component="img"
                src={BtnBGImg}
                alt="Server Status"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "#fff",
                  fontWeight: "bold",
                  textShadow: "0 1px 5px rgba(0,0,0,0.7)",
                  pointerEvents: "none",
                }}
              >
                Server Status: Online
              </Typography>
            </Box>
          </Grid>

          {/* RIGHT SIDE: Facebook Embed */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                border: "1px solid #3a3a3a",
                borderRadius: "8px",
                overflow: "hidden",
                maxWidth: 500,
                mx: "auto",
              }}
            >
              <div
                className="fb-page"
                data-href="https://www.facebook.com/darknovaconquer"
                data-tabs="timeline"
                data-width="500"
                data-height="540"
                data-small-header="true"
                data-adapt-container-width="true"
                data-hide-cover="false"
                data-show-facepile="true"
              >
                <blockquote
                  cite="https://www.facebook.com/darknovaconquer"
                  className="fb-xfbml-parse-ignore"
                >
                  <a href="https://www.facebook.com/darknovaconquer">
                    DarkNova Conquer
                  </a>
                </blockquote>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Home;
